export default 
{
  type: "form-terms",
  style: "",
  data: {
    desc: "I agree to the terms and conditions",
    freeText: `<p>I agree to the <a href="https://www.radicasys.com" target="_blank"><span style="color:#3498db;"><u>terms</u></span></a> and <a href="https://www.radicasys.com" target="_blank"><span style="color:#3498db;"><u>conditions</u></span></a>.</p>`,
    label: "Terms",
    required: true,
    termsType: "free",
  },
  children: [],
};
